module.exports = __webpack_public_path__ + "img/img-6-desk.f3c0c2b8.jpg";